import { render, staticRenderFns } from "./FeaturedPlayers.vue?vue&type=template&id=32f94ae1&scoped=true&"
import script from "./FeaturedPlayers.vue?vue&type=script&lang=js&"
export * from "./FeaturedPlayers.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPlayers.vue?vue&type=style&index=0&id=32f94ae1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f94ae1",
  null
  
)

export default component.exports